import React, { useContext, useEffect, useReducer, useState } from "react";
import Dialog from "@material-ui/core/Dialog";

import {
    createStyles,
    Grid,
    IconButton,
    makeStyles,
    Typography,

} from "@material-ui/core";
import tableIcons, { options } from "components/universal/table_attributes";
import MaterialTable from "material-table";
import { ToastMessageContext } from "lib/contexts/message_context";
import ShiftServices from "lib/services/api/planning/Shifts/shift";
import { getOrganisationId } from "lib/utils/common_utils";


const useStyles = makeStyles((theme) =>
    createStyles({
        modal: {
            "& .MuiDialog-paperWidthSm": {
                minWidth: "750px",
                // height: "110vh"
            },
        },
        container: {
            // minWidth: "1200px",
            // minHeight: "400px",
            padding: "50px",
            position: "relative",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden !important"
        },

        popupTitle: {
            fontSize: "20px",
            lineHeight: "28px",
            position: "absolute",
            top: "19px",
            bottom: "15px",
            left: "25px",
        },
        divider: {
            borderBottom: `1px solid ${theme.palette.primary.main}`,
        },
        tableTitle: {
            fontSize: "16px",
            lineHeight: "22px",
            color: "#4D4F5C",
            fontWeight: "bold",
            marginTop: "19px",
            marginBottom: "16px",
        },
        tableCell: {
            height: '32px',
            justifyContent: "space-between",
            whiteSpace: "normal",
            wordWrap: "break-word",

        },
    })
);

export default function UsedHours(props) {
    const { handleClose, currentSelection } = props
    const classes = useStyles();
    const message = useContext(ToastMessageContext);
    const [data, setData] = useState([])
    const [Loading, setLoading] = useState(false)



    const getListing = () => {

        const params = {
            organisation_id: getOrganisationId(),
            shift_id: currentSelection?.id,

        }

        setLoading(true)
        ShiftServices.getShiftUsedHoursDetails(params).then((res) => {
            setData([{
                "user_name": res.data.user_name,
                "item": "Shift Hours",
                "hours": res.data.shift_hours || 0

            }, {
                "user_name": res.data.user_name,
                "item": "Absence Hours",
                "hours": res.data.absence_hours || 0

            }, {
                "user_name": res.data.user_name,
                "item": "Leave Hours",
                "hours": res.data.leave_hours || 0

            }, {
                "user_name": res.data.user_name,
                "item": "Training Hours",
                "hours": res.data.training_hours || 0

            }])

        }).catch(() => {
            message.showToastMessage({
                message: "Something went wrong. Try again!",
                variant: "error",
            });
        }).finally(() => {
            setLoading(false)
        })

    }

    useEffect(() => {
        getListing()
    }, [currentSelection])

    const tableOptions = {
        ...options,
        paging: false,
        search: false,
        toolbar: false,
        rowStyle: { height: 42 },
    };

    const column = [

        {
            title: "User",
            field: "user_name",
            width: '20%',
            headerStyle: {
                textAlign: "left",
                paddingLeft: "15px",
                width: '20%',
            },
            cellStyle: {
                textAlign: "left",
                paddingLeft: "15px",
                width: '20%',
            },
        },
        {
            title: "Item",
            field: "item",
            width: '60%',
            headerStyle: {

                textAlign: "left",
            },
            cellStyle: {
                width: '60%',
                textAlign: "left",
            },

        },

        {
            title: "Hours",
            field: "hours",

        },
    ];





    return (
        <div>
            <Dialog
                open={true}
                onClose={handleClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
                className={classes.modal}
            >
                <div className={classes.container}>
                    <Typography
                        variant="body1"
                        color="primary"
                        style={{ marginBottom: "20px" }}
                        className={classes.popupTitle}
                    >
                        User Hours
                    </Typography>

                    <Grid item xs={6} style={{ marginTop: "10px", }}>
                        <MaterialTable
                            style={{
                                boxShadow: "0px 1px 3px #00000033",
                                borderRadius: "4px",
                                width: "650px",
                                // minWidth: "500px"
                            }}

                            options={tableOptions}
                            title=""
                            icons={tableIcons}
                            columns={column}
                            data={data || []}
                            isLoading={Loading}


                        />
                    </Grid>
                </div>
            </Dialog>

        </div>
    )
}
